export default "__VITE_ASSET__cNelT6ll__";